import { ArrowUpRight } from "lucide-react";
import { SERVICES, COPY } from "@/lib/site";
import { scrollToId } from "@/lib/lenisManager";
import { Reveal } from "./Motion";

export const Services = () => {
  return (
    <section id="services" data-testid="services-section" className="bg-surface py-24 md:py-36">
      <div className="container-editorial">
        <Reveal className="max-w-3xl mb-14 md:mb-20">
          <p className="kicker mb-6">{COPY.services.kicker}</p>
          <h2 className="font-display text-5xl md:text-7xl leading-[0.95] tracking-tight">
            {COPY.services.heading}
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-line border border-line rounded-sm overflow-hidden">
          {SERVICES.map((s, i) => (
            <Reveal
              key={s.title}
              delay={i * 0.08}
              data-testid={`service-${s.index}`}
              className="group bg-cream p-8 md:p-10 flex flex-col"
            >
              <span className="font-display text-2xl text-clay">{s.index}</span>
              <h3 className="font-display text-4xl mt-3 leading-none">{s.title}</h3>
              <p className="mt-4 text-sm font-light text-ink/70 leading-relaxed">
                {s.desc}
              </p>

              <ul className="mt-7 space-y-3 flex-1">
                {s.items.map((it) => (
                  <li key={it} className="flex items-start gap-3 text-sm text-ink/80">
                    <span className="mt-2 w-1 h-1 rounded-full bg-ink/60 shrink-0" />
                    {it}
                  </li>
                ))}
              </ul>

              <button
                data-testid={`service-cta-${s.index}`}
                onClick={() => scrollToId("contact")}
                className="mt-9 inline-flex items-center gap-2 text-[12px] font-semibold uppercase tracking-[0.16em] text-ink group-hover:gap-3 transition-all duration-300"
              >
                Discuss This
                <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </button>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1} className="mt-8 text-xs text-ink/50 font-light">
          {COPY.services.footnote}
        </Reveal>
      </div>
    </section>
  );
};
